<template>
    <svg width="1.125em" height="1.125em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L2 12H5V20H11V14H13V20H19V12H22L12 3ZM17 18H15V12H9V18H7V10.19L12 5.69L17 10.19V18Z" fill="currentColor"/>
        <path opacity="0.3" d="M7 10.19V18H9V12H15V18H17V10.19L12 5.69L7 10.19Z" fill="currentColor"/>
    </svg>
</template>
